function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "10.54 12.56 5.09 12.56 5.09 19.83 10.54 19.83 16 25.29 16 7.11 10.54 12.56",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.81,10.85a5.46,5.46,0,0,1,0,10.3",
    style: {
      fill: "none",
      stroke: "#7c7c7c",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.64,6a10.65,10.65,0,0,1,7.27,10,10.65,10.65,0,0,1-7.27,10",
    style: {
      fill: "none",
      stroke: "#7c7c7c",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardMessage);
export default __webpack_public_path__ + "static/media/forward-message.62c99439.svg";
export { ForwardRef as ReactComponent };